import { useEffect, useId, useState } from "react";
import DataTable from "react-data-table-component";
import { Form, Input, Label } from "reactstrap";
import { Button, Col, Icon, PreviewAltCard, Row } from "../../components/Component";
import MyLoader from "../Form/MyLoader";
import { exportToExcel, exportToExcel1 } from "../../utils/Utils";
import "./ApiPaginationDataTable.scss";

const ApiPaginationDataTable = ({
  data,
  columns,
  title,
  subtitle,
  isLoading,
  className,
  handleTabClick,
  showSecondTable,
  activeTab,
  handleBackClick,
  watch,
  showThirdTable,
  handleThirdTableBackClick,
  search,
  selectableRows,
  zoneList,
  tabs,
  handleImageOpenPreview,
  owner,
  exp,
  keysToExport,
  setValue,
  register,
  errors,
  trigger,
  handleSubmit,
  handleSearch,
  searchPlaceholder,
  date,
  type,
  zone,
  camp,
  campReq,
  handlePerRowsChange,
  handlePageChange,
  totalRows,
  perPage,
  dashTab,
  serverSearch,
  serverSideSearch,
  campUser,
  pos,
  session,
  Class,
  subject,
  subjectReq,
  chapter,
  chapterReq,
  expo,
  expA,
  expKeys,
  fileName,
  /** Reporting: status filter (all | active | inactive) */
  statusFilter,
  onStatusFilterChange,
  showStatusFilter,
  /** Clear search + filters (optional) */
  onClearFilters,
  /** Show active-filter hint */
  activeFilterSummary,
}) => {
  const statusFieldId = useId();

  const paginationComponentOptions = {
    rowsPerPageText: "Rows per page",
    rangeSeparatorText: "of",
    noRowsPerPage: false,
    selectAllRowsItem: true,
    selectAllRowsItemText: "All",
  };

  const customStyles = {
    headRow: {
      style: {
        border: "none",
        minHeight: "48px",
      },
    },
    headCells: {
      style: {
        color: "#526484",
        fontSize: "12px",
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "0.04em",
      },
    },
    rows: {
      style: {
        fontSize: "14px",
      },
      highlightOnHoverStyle: {
        backgroundColor: "rgba(231, 243, 255, 0.55)",
        borderBottomColor: "transparent",
        borderRadius: "4px",
      },
    },
    pagination: {
      style: {
        border: "none",
        paddingTop: "1rem",
      },
    },
  };

  const [filterText, setFilterText] = useState("");
  const [filteredItems, setFilteredItems] = useState(data);

  const isServerPagedTitle =
    title === "Users" ||
    title === "Registered Users" ||
    title === "Admin Users" ||
    serverSearch;

  useEffect(() => {
    let filteredData = data;
    if (isServerPagedTitle) {
      setFilteredItems(data);
      return;
    }
    switch (title) {
      case "Employee List":
        filteredData = data.filter((item) => {
          const filter = filterText.toLowerCase();
          const fullname = `${item.first_name} ${item.last_name}`;
          return (
            (fullname && fullname.toLowerCase().includes(filter)) ||
            (item.phone && item.phone.toLowerCase().includes(filter)) ||
            (item.pincode && item.pincode.toLowerCase().includes(filter)) ||
            (item.role && item.role.toLowerCase().includes(filter))
          );
        });
        break;
      case "Ward List":
        filteredData = data.filter((item) => {
          const filter = filterText.toLowerCase();
          return (
            (item.label && item.label.toLowerCase().includes(filter)) ||
            (item.zone_name && item.zone_name.toLowerCase().includes(filter)) ||
            (item.ward_code && item.ward_code.toLowerCase().includes(filter))
          );
        });
        break;
      default:
        break;
    }
    setFilteredItems(filteredData);
  }, [filterText, data, title, isServerPagedTitle]);

  const rowsPerPageOptions = [10, 25, 50, 100, 500];

  const serverSearchVal = watch ? watch("server_search") : "";

  return (
    <>
      <Row>
        <Col sm="12">
          <PreviewAltCard className={`report-data-table-card my-2`}>
              <div className="report-table-card-header">
                <div className="report-table-card-header__main">
                  <div className="report-table-card-header__title-row">
                    <h5 className="title mb-0">{title}</h5>
                    <div className="report-table-card-header__export">
                      {expo && filteredItems ? (
                        <Button
                          type="button"
                          color="primary"
                          title="Download spreadsheet"
                          className="report-table-btn-export"
                          onClick={() => {
                            exportToExcel(filteredItems, expKeys, fileName);
                          }}
                        >
                          <span className="report-table-btn-export__icon" aria-hidden>
                            <Icon name="download-cloud" />
                          </span>
                          <span>Export</span>
                        </Button>
                      ) : null}
                      {expA && filteredItems ? (
                        <Button
                          type="button"
                          color="primary"
                          title="Download spreadsheet"
                          className="report-table-btn-export"
                          onClick={() => {
                            exportToExcel1(filteredItems, expKeys, fileName);
                          }}
                        >
                          <span className="report-table-btn-export__icon" aria-hidden>
                            <Icon name="download-cloud" />
                          </span>
                          <span>Export</span>
                        </Button>
                      ) : null}
                    </div>
                  </div>
                  {subtitle ? <p className="report-table-card-header__subtitle text-soft small mb-0">{subtitle}</p> : null}
                  {activeFilterSummary ? (
                    <p className="text-primary small mb-0 mt-2 fw-medium">{activeFilterSummary}</p>
                  ) : null}
                </div>
              </div>

              <div className="report-table-toolbar">
                <div className="report-table-toolbar__search">
                  {serverSearch ? (
                    <div className="form-control-wrap">
                      <Label className="overline-title text-soft mb-1">Search</Label>
                      <div className="position-relative">
                        <div className="form-icon form-icon-right xl">
                          <Icon
                            name="search"
                            style={{
                              position: "absolute",
                              top: "50%",
                              transform: "translateY(-50%)",
                              right: "12px",
                              pointerEvents: "none",
                            }}
                          />
                        </div>
                        <Input
                          className="form-control"
                          type="text"
                          autoComplete="off"
                          placeholder={searchPlaceholder || "Search by name, phone…"}
                          value={serverSearchVal ?? ""}
                          onChange={(e) => setValue && setValue("server_search", e.target.value)}
                        />
                      </div>
                      <p className="report-table-toolbar__hint text-soft mb-0 mt-1">
                        Results update automatically as you type.
                      </p>
                    </div>
                  ) : (
                    <Form className="theme-form">
                      <Label className="overline-title text-soft mb-1">Search</Label>
                      <div className="form-control-wrap position-relative">
                        <div className="form-icon form-icon-right xl">
                          <Icon
                            name="search"
                            style={{
                              position: "absolute",
                              top: "50%",
                              transform: "translateY(-50%)",
                              right: "12px",
                              pointerEvents: "none",
                            }}
                          />
                        </div>
                        <Input
                          className="form-control"
                          type="text"
                          placeholder={searchPlaceholder || "Search…"}
                          value={filterText}
                          onChange={(e) => setFilterText(e.target.value)}
                        />
                      </div>
                    </Form>
                  )}
                </div>

                {(showStatusFilter && onStatusFilterChange) || onClearFilters ? (
                  <div className="report-table-toolbar__controls">
                    {showStatusFilter && onStatusFilterChange ? (
                      <div className="report-table-toolbar__filters">
                        <Label className="overline-title text-soft mb-1" htmlFor={statusFieldId}>
                          Account status
                        </Label>
                        <Input
                          id={statusFieldId}
                          type="select"
                          className="form-select report-table-toolbar__select"
                          value={statusFilter || "all"}
                          onChange={(e) => onStatusFilterChange(e.target.value)}
                        >
                          <option value="all">All statuses</option>
                          <option value="active">Active only</option>
                          <option value="inactive">Inactive only</option>
                        </Input>
                      </div>
                    ) : null}
                    {onClearFilters ? (
                      <div className="report-table-toolbar__reset">
                        <span className="report-table-toolbar__reset-label overline-title text-soft mb-1 d-block d-md-none">
                          Actions
                        </span>
                        <Button type="button" color="light" className="report-table-btn-reset" outline onClick={onClearFilters}>
                          <Icon name="reload" />
                          <span>Reset</span>
                        </Button>
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>

              <div className="nk-data data-list report-table-wrap">
                <DataTable
                  className={className}
                  columns={columns}
                  data={filteredItems}
                  progressPending={isLoading}
                  progressComponent={<MyLoader />}
                  noDataComponent={"There are no records to display"}
                  subHeader={false}
                  persistTableHead
                  striped
                  responsive
                  highlightOnHover
                  customStyles={customStyles}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows ?? 0}
                  paginationPerPage={perPage}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  paginationRowsPerPageOptions={rowsPerPageOptions}
                  paginationComponentOptions={paginationComponentOptions}
                />
              </div>
          </PreviewAltCard>
        </Col>
      </Row>
    </>
  );
};

export default ApiPaginationDataTable;
